module.exports = __webpack_public_path__ + "img/4-(6).e6fd59c1.jpg";